import { Grid } from "@mui/material";
import { Tag } from "antd";
import { memo } from "react";
import { FieldErrors, UseFormSetValue } from "react-hook-form";
import { ValidationSwitch } from "./ValidationSwitch";
import { ValidationTextArea } from "./ValidationTextArea";
import { ValidationMedia } from "./ValidationMedia";
import { useBlobUrl } from "../../../hooks";

interface ValidationComponentProps {
  errors?: FieldErrors<any>;
  setValue?: UseFormSetValue<any>;
  isVideo: boolean;
  src: string;
  setTextStore: any;
  setSwitchStore: any;
  textStore: string;
  switchStore: boolean;
  foto: string;
  setFoto: any;
  label: string;
  key: string;
  onAlert?: () => void;
}

export const ValidationItemComponent = memo(
  ({
    errors,
    setValue,
    isVideo,
    src,
    setTextStore,
    setSwitchStore,
    textStore,
    switchStore,
    foto,
    setFoto,
    label,
    key,
    onAlert,
  }: ValidationComponentProps) => {

    const fotoUrl = useBlobUrl(foto);
    const fotoUrlSrc = useBlobUrl(src);

    return (
      <Grid
        item
        xs={12}
        sx={{
          m: 0.3,
          display: "flex",
          justifyContent: "center",
          border: "0.2px solid #25D228",
          borderRadius: "5px",
          paddingTop: "10px",
          paddingLeft: "10px",
          paddingRight: "10px",
          paddingBottom: isVideo ? "50px" : "10px",
        }}
      >
        <Grid
          container
          spacing={1}
          alignContent="center"
          alignItems="center"
        >
          {/* Header con label */}
          <Grid item xs={6}>
            <Tag
              color="#0B0D0B"
              style={{
                width: "100%",
                height: "25px",
                fontWeight: "bold",
                color: "white",
              }}
            >
              {label}
            </Tag>
          </Grid>

          {/* Switch Component - Memoizado */}
          <Grid item xs={6} sx={{ display: "flex", justifyContent: "center" }}>
            <ValidationSwitch
              switchStore={switchStore}
              setSwitchStore={setSwitchStore}
            />
          </Grid>

          {/* TextArea y Cámara - Memoizado */}
          <Grid item xs={6}>
            <ValidationTextArea
              textStore={textStore}
              setTextStore={setTextStore}
              foto={fotoUrl}
              setFoto={setFoto}
              isVideo={isVideo}
            />
          </Grid>

          {/* Media Display - Memoizado */}
          <Grid
            item
            xs={6}
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <ValidationMedia isVideo={isVideo} src={fotoUrlSrc} />
          </Grid>
        </Grid>
      </Grid>
    );
  }
);